export const speedRun_v0 = [
  {
    breakerId: 'Mimosa',
    additionalData: {
      time: -147070,
    },
    position: 0,
  },
  {
    breakerId: 'stylepiggy',
    additionalData: {
      time: -147553,
    },
    position: 1,
  },
  {
    breakerId: 'KayeL',
    additionalData: {
      time: -148205,
    },
    position: 2,
  },
  {
    breakerId: 'Jhiva',
    additionalData: {
      time: -148448,
    },
    position: 3,
  },
  {
    breakerId: 'lil_yuzu',
    additionalData: {
      time: -149761,
    },
    position: 4,
  },
  {
    breakerId: 'Neptune',
    additionalData: {
      time: -150041,
    },
    position: 5,
  },
  {
    breakerId: 'Camomile',
    additionalData: {
      time: -150283,
    },
    position: 6,
  },
  {
    breakerId: 'EKV',
    additionalData: {
      time: -152013,
    },
    position: 7,
  },
  {
    breakerId: 'drynkyuong',
    additionalData: {
      time: -152621,
    },
    position: 8,
  },
  {
    breakerId: 'oItsfranco',
    additionalData: {
      time: -154183,
    },
    position: 9,
  },
  {
    breakerId: 'Kato',
    additionalData: {
      time: -155438,
    },
    position: 10,
  },
  {
    breakerId: 'JuhJimmy',
    additionalData: {
      time: -156480,
    },
    position: 11,
  },
  {
    breakerId: 'Airs',
    additionalData: {
      time: -159068,
    },
    position: 12,
  },
  {
    breakerId: 'InventorBLADES',
    additionalData: {
      time: -161565,
    },
    position: 13,
  },
  {
    breakerId: 'Igor_Kara',
    additionalData: {
      time: -163312,
    },
    position: 14,
  },
  {
    breakerId: '10000$',
    additionalData: {
      time: -165978,
    },
    position: 15,
  },
  {
    breakerId: 'ZRoman',
    additionalData: {
      time: -170166,
    },
    position: 16,
  },
  {
    breakerId: 'Shiba',
    additionalData: {
      time: -170194,
    },
    position: 17,
  },
  {
    breakerId: 'DROBOSHENKO',
    additionalData: {
      time: -172834,
    },
    position: 18,
  },
  {
    breakerId: 'Zippovikof',
    additionalData: {
      time: -181926,
    },
    position: 19,
  },
  {
    breakerId: 'Branxi',
    additionalData: {
      time: -182515,
    },
    position: 20,
  },
  {
    breakerId: 'Romario',
    additionalData: {
      time: -211514,
    },
    position: 21,
  },
  {
    breakerId: 'Fenrir',
    additionalData: {
      time: -211900,
    },
    position: 22,
  },
  {
    breakerId: 'Cyberya',
    additionalData: {
      time: -221034,
    },
    position: 23,
  },
  {
    breakerId: 'UAENA',
    additionalData: {
      time: -225447,
    },
    position: 24,
  },
  {
    breakerId: 'Slayer',
    additionalData: {
      time: -232665,
    },
    position: 25,
  },
  {
    breakerId: 'Lux',
    additionalData: {
      time: -240375,
    },
    position: 26,
  },
  {
    breakerId: 'RAVI',
    additionalData: {
      time: -242703,
    },
    position: 27,
  },
  {
    breakerId: 'Drummer',
    additionalData: {
      time: -247482,
    },
    position: 28,
  },
  {
    breakerId: 'Jedion',
    additionalData: {
      time: -251786,
    },
    position: 29,
  },
  {
    breakerId: 'KekksikAngry',
    additionalData: {
      time: -255185,
    },
    position: 30,
  },
  {
    breakerId: 'Zvonock',
    additionalData: {
      time: -262255,
    },
    position: 31,
  },
  {
    breakerId: 'Ka4ka',
    additionalData: {
      time: -264581,
    },
    position: 32,
  },
  {
    breakerId: 'Romko.eth',
    additionalData: {
      time: -264870,
    },
    position: 33,
  },
  {
    breakerId: 'ownedmk1',
    additionalData: {
      time: -268995,
    },
    position: 34,
  },
  {
    breakerId: '3oHTuK',
    additionalData: {
      time: -301362,
    },
    position: 35,
  },
  {
    breakerId: 'First',
    additionalData: {
      time: -309231,
    },
    position: 36,
  },
  {
    breakerId: 'vitaG',
    additionalData: {
      time: -319352,
    },
    position: 37,
  },
  {
    breakerId: 'Sfinkzzz',
    additionalData: {
      time: -323039,
    },
    position: 38,
  },
  {
    breakerId: 'LilyPen',
    additionalData: {
      time: -335712,
    },
    position: 39,
  },
  {
    breakerId: 'AldoDiaz',
    additionalData: {
      time: -337826,
    },
    position: 40,
  },
];
